define('models/PaymentBrandModel',[
    'underscore','backbone','ObjectModel','app'
],function (
        _,Backbone,ObjectModel,app
    ) {
    //
    // Model PaymentBrand
    //
    var PaymentBrandModelPrototype = {
        
        name:'PaymentBrandModel',
        route:'apiPaymentBrandModel',
        // TODO attention, l'idAttribute n'est pas `id_payment_brand` (car pas migré)
        idAttribute:'id_payment_brand',
        defaults:{
            pictures:[]
        },
        
        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
        },
        isDirectLink:function(){
            return !!this.get('directlink');
        },
        getPictureUrl:function(){
            var model = this,
                pictureUrl = '',
                pictures = model.get('pictures'),
                picture;
            if(pictures.length){
                picture = pictures[0];
                pictureUrl = app.getPictureUrl(picture.id_object_picture,'paymentbrand','120x72','PNG',model.get('brand'));
            }
            return pictureUrl;
        }
    };

    var PaymentBrandModel = ObjectModel.extend(PaymentBrandModelPrototype);
    
    return PaymentBrandModel;
});
